import React, { Component } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import SucceessIcon from "../../assets/img/succeess_icon.svg";
import { FORGOT_PASSWORD } from "../../utils/";
import { post } from "../../utils/";
import Logo from "../../assets/img/logo.svg";
import "../../assets/css/common.scss";
import queryString from "query-string";
import BaseService from "../../store/services/base.service";
import passwordStrength from "pwd-strength";
import { withTranslation } from "react-i18next";
import { WEBSITE_URL } from "../../config";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errmsg: "",
      errorText: "",
      checkpage: true,
      page1: false,
      page2: false,
      email: "",
      code: "",
      password: "",
      confirmpassword: "",
      id: "",
      supportmail: "support@cybernetyx.com"
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    console.log(values.email);
    console.log(values.token);
    if (values.email && values.token) {
      this.verifyResetCode(values.email, values.token);
    } else {
      this.props.history.push("/forgotpassword");
    }
  }

  verifyResetCode = async (email, token) => {
    let self = this;
    const url = FORGOT_PASSWORD.verifyRecoveryCode();

    await new BaseService().makePostRequestGeneric(url, {
      email: email.toLowerCase(),
      token: token,
      role: "learner"
    });
    this.setState({ checkpage: false, page1: true });
    this.setState({ email: email });
  };

  onPasswordEnter(event) {
    this.setState({ password: event.target.value });
    this.setState({ passworderrorstatus: false, passworderrorText: "" });
  }

  onConfirmPasswordEnter(event) {
    this.setState({ confirmpassword: event.target.value });
    this.setState({
      confirmpassworderrorstatus: false,
      confirmpassworderrorText: ""
    });
  }

  resetPasswordClick = async () => {
    if (this.state.password === "") {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Enter Password" });
    } else if (this.state.password.length < 8) {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Password too short." });
    } else if (
      !passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1
      }).success
    ) {
      let errorMsg = passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1
      }).message;
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: errorMsg });
    } else if (!passwordStrength(this.state.password).success) {
      this.setState({ passworderrorstatus: true });
      this.setState({
        passworderrorText: "Password is not safe. Please try another password"
      });
    } else if (this.state.confirmpassword === "") {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Re-Enter Password" });
    } else if (this.state.confirmpassword !== this.state.password) {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Password MisMatch" });
    } else {
      const url = FORGOT_PASSWORD.resetPassword();
      await new BaseService().makePostRequestGeneric(url, {
        email: this.state.email.toLowerCase(),
        password: this.state.password
      });
      this.setState({ errmsg: "Password Changed Successfully" });
      this.setState({ openerrmsg: true });
      this.setState({ page1: false, page2: true });
    }
  };

  loginClick = () => {
    // this.props.history.push("/");
    window.location.replace(WEBSITE_URL);
  };

  render() {
    const { t } = this.props;
    if (this.state.checkpage) {
      return (
        <div>
          {
            <div className="card signin-card">
              <div className="text-left mb-2">
                <img src={Logo} alt="Logo" />
              </div>
              <div>
                <p
                  className={
                    this.state.openerrmsg ? "show text-center" : "hide"
                  }
                >
                  {t("Please Wait..")}
                </p>
              </div>
              <div>
                <p
                  className={
                    this.state.openerrmsg
                      ? "hide text-center"
                      : "show text-center"
                  }
                >
                  {this.state.errmsg}
                </p>
              </div>
              <div>
                <p className="text-center">
                  {t("If not redirected please mail to")}{" "}
                  {this.state.supportmail}{" "}
                </p>
              </div>
            </div>
          }
          <Snackbar
            message={this.state.errmsg}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
        </div>
      );
    } else if (this.state.page1) {
      return (
        <div>
          {
            <div className="card signin-card">
              <div className="text-left mb-2">
                <img src={Logo} alt="Logo" />
              </div>
              <div>
                <p className="header-title">{t("Reset password")}</p>
              </div>
              <div className="passwordbox">
                {" "}
                <TextField
                  type="password"
                  label="New password"
                  className="passwordbox"
                  margin="normal"
                  style={emailbox}
                  value={this.state.password}
                  helperText={this.state.passworderrorText}
                  error={this.state.passworderrorstatus}
                  onChange={this.onPasswordEnter.bind(this)}
                />
              </div>
              <div className="passwordbox">
                {" "}
                <TextField
                  type="password"
                  label="Re-enter password"
                  className="passwordbox"
                  margin="normal"
                  style={emailbox}
                  value={this.state.confirmpassword}
                  helperText={this.state.confirmpassworderrorText}
                  error={this.state.confirmpassworderrorstatus}
                  onChange={this.onConfirmPasswordEnter.bind(this)}
                />
              </div>
              <div className="margin-center">
                <button
                  className="btn-button-learn col-full"
                  onClick={this.resetPasswordClick}
                >
                  {t("Confirm")}
                </button>
              </div>
            </div>
          }
          <Snackbar
            message={this.state.errmsg}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
        </div>
      );
    } else if (this.state.page2) {
      return (
        <div>
          {
            <div className="card signin-card">
              <div className="text-left mb-2">
                <img src={Logo} alt="Logo" />
              </div>
              <div className="text-center header-title">
                <p>{t("Reset password succesful")}</p>
              </div>
              <div>
                <p className="text-center text-black">
                  {t("Please use your new password when signing in")}.
                </p>
              </div>
              <div className="text-center">
                <img src={SucceessIcon} alt="" className="successlogo-img" />
              </div>
              <div className="text-center">
                <button
                  className="btn-button-learn col-full"
                  onClick={this.loginClick}
                >
                  {t("Go to Sign In")}>
                </button>
              </div>
            </div>
          }
          <Snackbar
            message={this.state.errmsg}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
        </div>
      );
    }
  }
}

const emailbox = {
  marginTop: "-5px"
};

export default withTranslation()(ResetPassword);
